"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getGitHubIssueOrPullRequestSubItems = exports.getGitHubIssueSearchQuery = exports.sortIssuesOrPullRequests = exports.enhanceIssueOrPullRequests = exports.getIssueOrPullRequestsEnhancementMap = exports.createIssuesOrPullRequestsCache = exports.getOlderOrNewerIssueOrPullRequestDate = exports.getIssueOrPullRequestSubjectType = exports.getIssueOrPullRequestState = exports.mergeIssueOrPullRequestPreservingEnhancement = exports.mergeIssuesOrPullRequestsPreservingEnhancement = exports.getIssueOrPullRequestIconAndColor = exports.issueOrPullRequestSubjectTypes = void 0;
const axios_1 = __importDefault(require("axios"));
const immer_1 = __importDefault(require("immer"));
const lodash_1 = __importDefault(require("lodash"));
const utils_1 = require("../../utils");
const filters_1 = require("../filters");
const shared_1 = require("../shared");
const shared_2 = require("./shared");
const url_1 = require("./url");
exports.issueOrPullRequestSubjectTypes = [
    'Issue',
    'PullRequest',
];
function getIssueOrPullRequestIconAndColor(type, issueOrPullRequest) {
    return type === 'PullRequest'
        ? shared_2.getPullRequestIconAndColor(issueOrPullRequest)
        : shared_2.getIssueIconAndColor(issueOrPullRequest);
}
exports.getIssueOrPullRequestIconAndColor = getIssueOrPullRequestIconAndColor;
function mergeIssuesOrPullRequestsPreservingEnhancement(newItems, prevItems, { dropPrevItems } = {}) {
    const allItems = dropPrevItems
        ? newItems || []
        : lodash_1.default.concat(newItems || [], prevItems || []);
    return sortIssuesOrPullRequests(lodash_1.default.uniqBy(allItems, 'id').map(item => {
        const newItem = (newItems || []).find(i => i.id === item.id);
        const existingItem = prevItems.find(i => i.id === item.id);
        return mergeIssueOrPullRequestPreservingEnhancement(newItem, existingItem);
    }));
}
exports.mergeIssuesOrPullRequestsPreservingEnhancement = mergeIssuesOrPullRequestsPreservingEnhancement;
function mergeIssueOrPullRequestPreservingEnhancement(newItem, existingItem) {
    if (!(newItem && existingItem))
        return newItem || existingItem;
    const enhancements = {
        enhanced: existingItem.enhanced,
        last_read_at: lodash_1.default.max([existingItem.last_read_at, newItem.last_read_at]),
        last_saved_at: lodash_1.default.max([existingItem.last_saved_at, newItem.last_saved_at]),
        last_unread_at: lodash_1.default.max([
            existingItem.last_unread_at,
            newItem.last_unread_at,
        ]),
        last_unsaved_at: lodash_1.default.max([
            existingItem.last_unsaved_at,
            newItem.last_unsaved_at,
        ]),
        merged: existingItem.merged,
        private: existingItem.private,
    };
    return immer_1.default(newItem, draft => {
        Object.entries(enhancements).forEach(([key, value]) => {
            if (typeof value === 'undefined')
                return;
            if (value === draft[key])
                return // if (typeof (draft as any)[key] !== 'undefined') return
                ;
            draft[key] = value;
        });
        draft.updated_at = lodash_1.default.max([existingItem.updated_at, newItem.updated_at]);
    });
}
exports.mergeIssueOrPullRequestPreservingEnhancement = mergeIssueOrPullRequestPreservingEnhancement;
function getIssueOrPullRequestState(item) {
    if (!item)
        return null;
    const isPR = shared_2.isPullRequest(item);
    if ((isPR && ('merged' in item && item.merged)) ||
        ('merged_at' in item && item.merged_at))
        return 'merged';
    return item.state || null;
}
exports.getIssueOrPullRequestState = getIssueOrPullRequestState;
function getIssueOrPullRequestSubjectType(item) {
    if (!item)
        return null;
    if (item.pull_request)
        return 'PullRequest';
    if (item.html_url && item.html_url.includes('/pull/'))
        return 'PullRequest';
    if (item.url && item.url.includes('/pulls/'))
        return 'PullRequest';
    if (item.html_url && item.html_url.includes('/issues/'))
        return 'Issue';
    if (item.url && item.url.includes('/issues/'))
        return 'Issue';
    return null;
}
exports.getIssueOrPullRequestSubjectType = getIssueOrPullRequestSubjectType;
function getOlderOrNewerIssueOrPullRequestDate(order, items, { field = 'updated_at', ignoreFutureDates = true, } = {}) {
    const now = Date.now();
    return sortIssuesOrPullRequests(items, field, order === 'newer' ? 'desc' : 'asc')
        .map(item => item[field])
        .filter(date => !!(date && ignoreFutureDates ? now > new Date(date).getTime() : true))[0];
}
exports.getOlderOrNewerIssueOrPullRequestDate = getOlderOrNewerIssueOrPullRequestDate;
function createIssuesOrPullRequestsCache(items, _cache) {
    const cache = _cache || new Map();
    if (!(items && items.length))
        return cache;
    const checkAndFix = (data, url, date) => {
        if (!cache.has(url)) {
            cache.set(url, { data, timestamp: new Date(date).valueOf() });
        }
    };
    items.forEach(item => {
        checkAndFix(item, item.url, item.updated_at);
    });
    return cache;
}
exports.createIssuesOrPullRequestsCache = createIssuesOrPullRequestsCache;
async function getIssueOrPullRequestsEnhancementMap(items, { cache = new Map(), getGitHubPrivateTokenForRepo, githubToken: _githubToken, }) {
    const repoMetas = lodash_1.default.uniqBy(items
        .map(item => {
        const repoURL = url_1.getRepoUrlFromOtherUrl(item && (item.repository_url || item.url));
        const { owner, repo } = shared_2.getOwnerAndRepo(url_1.getRepoFullNameFromUrl(repoURL || ''));
        let repoAPIURL = url_1.getBaseAPIUrlFromOtherAPIUrl(item && item.url);
        if (repoAPIURL && owner && repo)
            repoAPIURL = `${repoAPIURL}/repos/${owner}/${repo}`;
        return { repoURL, repoAPIURL, owner, repo };
    })
        .filter(meta => !!(meta &&
        meta.owner &&
        meta.repo &&
        meta.repoAPIURL &&
        meta.repoURL)), 'repoAPIURL');
    const repoPromises = repoMetas.map(async ({ repoURL, repoAPIURL, owner, repo }) => {
        const cacheValue = cache.get(repoURL);
        if (cacheValue && Date.now() - cacheValue.timestamp < 1000 * 60 * 60)
            return cacheValue;
        const privateToken = getGitHubPrivateTokenForRepo(owner, repo);
        const githubToken = privateToken || _githubToken;
        try {
            const { data } = await axios_1.default.get(repoAPIURL, {
                headers: {
                    Authorization: githubToken && `token ${githubToken}`,
                },
            });
            cache.set(repoURL, { data, timestamp: Date.now() });
        }
        catch (error) {
            console.error('Failed to load repository.', repoAPIURL, repoURL, error);
            cache.set(repoURL, false);
        }
    });
    await Promise.all(repoPromises);
    const promises = items.map(async (item) => {
        const repoURL = url_1.getRepoUrlFromOtherUrl(item && (item.repository_url || item.url));
        const repoFullName = url_1.getRepoFullNameFromUrl(repoURL);
        const { owner, repo } = shared_2.getOwnerAndRepo(repoFullName);
        if (!(owner && repo && item.number && item.url))
            return;
        const privateToken = getGitHubPrivateTokenForRepo(owner, repo);
        const githubToken = privateToken || _githubToken;
        const enhance = {};
        const mergeUrl = `${item.url.replace('/issues/', '/pulls/')}/merge`;
        const hasMergedCache = cache.has(mergeUrl);
        const mergedCache = cache.get(mergeUrl);
        const repoCacheValue = cache.get(repoURL);
        if (repoCacheValue && repoCacheValue.data) {
            enhance.private = repoCacheValue.data.private;
        }
        if (getIssueOrPullRequestSubjectType(item) === 'PullRequest' &&
            (!hasMergedCache ||
                (mergedCache &&
                    item.updated_at &&
                    new Date(item.updated_at).valueOf() > mergedCache.timestamp))) {
            try {
                const { status } = await axios_1.default.get(mergeUrl, {
                    headers: {
                        Authorization: githubToken && `token ${githubToken}`,
                    },
                    validateStatus: s => s === 204 || s === 404,
                });
                enhance.merged = status === 204;
                enhance.enhanced = true;
                cache.set(mergeUrl, { data: enhance.merged, timestamp: Date.now() });
            }
            catch (error) {
                console.error('Failed to load pull request merge status', mergeUrl, error);
                cache.set(mergeUrl, false);
                if (!enhance.enhanced)
                    enhance.enhanced = false;
            }
        }
        else if (hasMergedCache) {
            if (mergedCache && typeof mergedCache.data === 'boolean') {
                enhance.merged = mergedCache.data;
                enhance.enhanced = true;
            }
            else if (!enhance.enhanced)
                enhance.enhanced = false;
        }
        if (!Object.keys(enhance).length)
            return;
        return { id: item.id, enhance };
    });
    const enhancements = await Promise.all(promises);
    const enhancementMap = enhancements.reduce((map, payload) => payload
        ? {
            ...map,
            [payload.id]: payload.enhance,
        }
        : map, {});
    return enhancementMap;
}
exports.getIssueOrPullRequestsEnhancementMap = getIssueOrPullRequestsEnhancementMap;
function enhanceIssueOrPullRequests(items, enhancementMap, currentEnhancedIssueOrPullRequests = []) {
    if (!(items && items.length))
        return utils_1.constants.EMPTY_ARRAY;
    return items.map(item => {
        const enhanced = currentEnhancedIssueOrPullRequests.find(i => i.id === item.id);
        const enhance = enhancementMap[item.id];
        if (!enhance) {
            if (!enhanced)
                return item;
            return mergeIssueOrPullRequestPreservingEnhancement(item, enhanced);
        }
        return {
            ...mergeIssueOrPullRequestPreservingEnhancement(item, enhanced),
            ...enhance,
        };
    });
}
exports.enhanceIssueOrPullRequests = enhanceIssueOrPullRequests;
function sortIssuesOrPullRequests(items, field = 'updated_at', order = 'desc') {
    if (!(items && items.length))
        return utils_1.constants.EMPTY_ARRAY;
    return lodash_1.default(items)
        .uniqBy('id')
        .orderBy(field, order)
        .value();
}
exports.sortIssuesOrPullRequests = sortIssuesOrPullRequests;
function getGitHubIssueSearchQuery(params, includeDefaultSorting = true) {
    const queries = [];
    const { draft, involves, owners, state, subjectType, query } = params;
    if (query) {
        const termsToSearchFor = shared_1.getSearchQueryTerms(query);
        const convertedQuery = termsToSearchFor
            .map(queryTerm => {
            if (!(queryTerm &&
                Array.isArray(queryTerm) &&
                (queryTerm.length === 2 || queryTerm.length === 3)))
                return '';
            const [key, _value, isNegated] = queryTerm.length === 2 ? ['', queryTerm[0], queryTerm[1]] : queryTerm;
            if (!(_value && typeof _value === 'string'))
                return false;
            const value = _value.includes(' ') && _value[0] !== '"' ? `"${_value}"` : _value;
            const searchTerm = key
                ? `${key}:${value}`
                : value.match(/^#([0-9]+)$/) && value.match(/^#([0-9]+)$/)[1]
                    ? value.match(/^#([0-9]+)$/)[1]
                    : value;
            return isNegated
                ? key
                    ? `-${searchTerm}`
                    : `NOT ${searchTerm}`
                : searchTerm;
        })
            .filter(Boolean)
            .join(' ');
        queries.push(convertedQuery);
    }
    if (owners) {
        Object.entries(owners || {}).forEach(([owner, ownerFilter]) => {
            if (!(owner && ownerFilter))
                return;
            const reposToPush = [];
            Object.entries(ownerFilter.repos || {}).forEach(([repo, repoFilterValue]) => {
                if (!(repo && repoFilterValue === true))
                    return;
                const repoFullName = `${owner}/${repo}`.toLowerCase();
                reposToPush.push(repoFullName);
            });
            if (ownerFilter.value === true && !reposToPush.length)
                queries.push(`user:${owner}`.toLowerCase());
            reposToPush.forEach(repoFullName => queries.push(`repo:${repoFullName}`));
        });
    }
    if (involves && filters_1.filterRecordHasAnyForcedValue(involves)) {
        Object.entries(involves).forEach(([_user, value]) => {
            const user = `${_user || ''}`.trim().toLowerCase();
            if (!(user && typeof value === 'boolean'))
                return;
            const negationSign = !value ? '-' : '';
            queries.push(`${negationSign}involves:${user}`);
        });
    }
    if (subjectType === 'Issue')
        queries.push('is:issue');
    else if (subjectType === 'PullRequest')
        queries.push('is:pr');
    if (typeof draft === 'boolean') {
        if (draft)
            queries.push('is:draft');
        else
            queries.push('-is:draft');
    }
    if (state && filters_1.filterRecordHasAnyForcedValue(state)) {
        const open = filters_1.itemPassesFilterRecord(state, 'open', true) ? 'open' : '';
        const closed = filters_1.itemPassesFilterRecord(state, 'closed', true) ? 'closed' : '';
        const merged = filters_1.itemPassesFilterRecord(state, 'merged', true) ? 'merged' : '';
        const includesExactly = [open, closed, merged].filter(Boolean).join(',');
        switch (includesExactly) {
            // 001
            case 'merged': {
                queries.push('is:merged');
                break;
            }
            // 010
            case 'closed': {
                queries.push('state:closed');
                break;
            }
            // 011
            case 'closed,merged': {
                queries.push('-state:open');
                break;
            }
            // 100
            case 'open': {
                queries.push('state:open');
                break;
            }
            // 101 (NOT POSSIBLE ON GITHUB)
            // case 'open,merged': {
            //   queries.push('is:merged')
            //   break
            // }
            // 110 (NOT POSSIBLE ON GITHUB)
            // case 'open,closed': {
            //   queries.push('is:unmerged')
            //   break
            // }
            // 000 (not valid)
            // 111 (return all)
            default: {
                break;
            }
        }
    }
    if (includeDefaultSorting) {
        const searchTerms = shared_1.getSearchQueryTerms(query);
        if (!searchTerms.find(searchTerm => searchTerm &&
            Array.isArray(searchTerm) &&
            searchTerm.length === 3 &&
            searchTerm[0] === 'sort')) {
            queries.push('sort:updated-desc');
        }
    }
    return queries.join(' ');
}
exports.getGitHubIssueSearchQuery = getGitHubIssueSearchQuery;
function getGitHubIssueOrPullRequestSubItems(issueOrPullRequest) {
    const repoURL = url_1.getRepoUrlFromOtherUrl(issueOrPullRequest.repository_url ||
        issueOrPullRequest.url ||
        issueOrPullRequest.html_url);
    const repoFullName = repoURL && url_1.getRepoFullNameFromUrl(repoURL);
    const { owner: repoOwnerName, repo: repoName } = shared_2.getOwnerAndRepo(repoFullName || '');
    const iconDetails = getIssueOrPullRequestIconAndColor(getIssueOrPullRequestSubjectType(issueOrPullRequest) || 'Issue', issueOrPullRequest);
    const isRead = shared_2.isItemRead(issueOrPullRequest);
    const isSaved = shared_2.isItemSaved(issueOrPullRequest);
    const isPrivate = shared_1.isIssueOrPullRequestPrivate(issueOrPullRequest);
    const canSee = !isPrivate;
    return {
        canSee,
        iconDetails,
        isPrivate,
        isRead,
        isSaved,
        repoFullName,
        repoName,
        repoOwnerName,
        repoURL,
    };
}
exports.getGitHubIssueOrPullRequestSubItems = getGitHubIssueOrPullRequestSubItems;
//# sourceMappingURL=issues.js.map